import { Component, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { EventEmitter } from 'protractor';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {

  //@Output('search') searchEmitter = new EventEmitter<string>();
  //value: string;
  //search = new FormControl('')

  constructor() { }

  ngOnInit(): void {
  //this.search.valueChanges.subscribe(value => this.searchEmitter.emit(value))

  }






}
